import React from 'react';
import { Audio, CirclesWithBar } from  'react-loader-spinner'
import styles from './loading.module.css';

export const ImageLoadingScreen: React.FC<any> = ()=>{
    return(
        <div className={styles.backdrop}>
            <Audio color="#FF5A3C"/>
        </div>
    )
}
const LoadingScreen: React.FC<any> = () =>{

    return(
        <div className={styles.backdrop}>
            <CirclesWithBar color="#FF5A3C"/>
        </div>
    )
}

export default LoadingScreen;